const validationConditions: { [key: string]: string } = {
  "server_user_name": "Invalid server username, valid characters are a-z, A-Z, 0-9, _ , -, .",
  "server_user_password": "Invalid server user password, should contain at least one uppercase letter, one lowercase letter, one number and one of the following symbols: !{}:.",
  "server_user_password_symbols": "Invalid server user password, should contain at least one of the following symbols: !{}:.",
  "server_user_password_numbers": "Invalid server user password, should contain at least one number.",
  "invalid_tax_id": "Invalid tax id",
  "customer_password_validator": "Invalid customer password, should contain at least one uppercase letter, one lowercase letter, one number and one of the following symbols: !{}:.",
  "customer_password_symbols_validator": "Invalid customer password, should contain at least one of the following symbols: !{}:.",
  "customer_password_numbers_validator": "Invalid customer password, should contain at least one number.",
}

export default validationConditions;
